"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCurrentLocation = void 0;
var _queryString = require("../constants/queryString");
var _getQueryParameter = require("./getQueryParameter");
const trailingSlashRegex = /\/$/;
const removeTrailingSlash = url => url.replace(trailingSlashRegex, '');
const isCurrentLocation = url => {
  if (!url) {
    return false;
  }
  const queryStringIndex = url.indexOf('?');
  const cleanUrl = removeTrailingSlash(queryStringIndex > -1 ? url.slice(0, queryStringIndex) : url);
  const cleanPathname = removeTrailingSlash(document.location.pathname.replace(trailingSlashRegex, ''));
  if (cleanPathname === cleanUrl) {
    const currentIframeUrl = (0, _getQueryParameter.getQueryParameter)(_queryString.QUERYSTRING_IFRAMEURL);
    const urlSearch = queryStringIndex > -1 ? url.slice(queryStringIndex) : undefined;
    const urlQueryParameters = new URLSearchParams(urlSearch);
    const urlIframeUrl = urlQueryParameters.get(_queryString.QUERYSTRING_IFRAMEURL);
    return currentIframeUrl === urlIframeUrl;
  }
  return false;
};
exports.isCurrentLocation = isCurrentLocation;